import { render, staticRenderFns } from "./CovidVaccineIndex.vue?vue&type=template&id=4cae42a1&scoped=true&"
import script from "./CovidVaccineIndex.vue?vue&type=script&lang=js&"
export * from "./CovidVaccineIndex.vue?vue&type=script&lang=js&"
import style0 from "./CovidVaccineIndex.vue?vue&type=style&index=0&id=4cae42a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cae42a1",
  null
  
)

export default component.exports